/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import Grid from '@mui/material/Grid';
import { type UseFormReturn } from 'react-hook-form';
import {
  DragDropContext,
  Droppable,
  Draggable,
  type OnDragEndResponder
} from 'react-beautiful-dnd';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

import ContentBox, { ISurveyQuestion } from './ContentBox';

const styles = {
  grid1: {
    overflowX: 'hidden',
    overflowY: 'auto',
    width: 'auto',
    padding: {
      xs: '5px',
      sm: '0 1rem',
      lg: '0 3rem'
    }
  },
  card: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      sm: 'row'
    },
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 'auto',
    margin: '25px 0px',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '5px',
    boxShadow:
      'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;',
    padding: '2rem',
    gap: '2rem'
  }
};

interface IProps {
  surveyQuestions?: ISurveyQuestion[];
  form?: UseFormReturn;
  readOnly?: boolean;
  isEditable?: boolean;
  onDragEnd?: OnDragEndResponder;
  onRemove?: (id: string) => void;
  onDuplicate?: (id: string) => void;
  onChangeOption?: (option: string, id: string) => void;
  onRequired?: (id: string, value: boolean) => void;
  onChangeInputs?: (
    id: string,
    key: 'label' | 'options',
    value: number | string
  ) => void;
}

function Question({
  form,
  surveyQuestions,
  onDragEnd,
  onChangeOption,
  ...extraProps
}: IProps) {  

  return (
    <Grid data-testid="survey-question-list-container" sx={styles.grid1}>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {surveyQuestions?.map((question, index) => (
                <Draggable
                  draggableId={question.orderItem}
                  index={index}
                  isDragDisabled={!extraProps?.isEditable}
                  key={question.orderItem}
                >
                  {(providedInsideMap) => (
                    <Grid
                      ref={providedInsideMap.innerRef}
                      {...providedInsideMap.draggableProps}
                      {...providedInsideMap.dragHandleProps}
                      sx={styles.card}
                    >
                      {extraProps?.isEditable && <DragIndicatorIcon />}
                      <Grid
                        display="flex"
                        justifyContent="space-between"
                        width="100%"
                      >
                        <ContentBox
                          form={form}
                          id={question?.orderItem}
                          isReadOnly={extraProps.readOnly}
                          isRequired={question.isRequired}
                          itemFull={question}
                          onChange={(type) =>
                            onChangeOption(type, question?.orderItem)
                          }
                          optionsLine={question?.options}
                          value={question}
                          {...extraProps}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Grid>
  );
}

export default Question;
